const rpArgsRx = (data, elemento1, saldoCl, valorServ, valorAntesI, ultMF, listColeccRPCC, valorPag,
    numDF, numDM, userLogin, fechaHoraHoy) => {
  // let fechaHoy = new Date()
  // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  
  let agnoFra = fechaHoy.substr(0, 4)
  let mesFra = fechaHoy.substr(5, 2)

  let diaFra= parseInt(fechaHoy.substr(8, 2), 10)
  let periodoFrado = ""

  periodoFrado = fechaHoy.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
  periodoFrado += ' a ' + fechaHoy.substr(0, 8) + numDM

  let imptosServ = elemento1.imptos.map(impto => ({
    ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))

//CREA REGISTRO EN movclientes
//  saldoCl += valorServ
  // console.log("55")

  let creaColeccI = [], creaColecc = []
  let argsUpd = {}
  imptosServ.forEach((elementoI, ii) => {
    if(elementoI.codigoImpto!==null){
      argsUpd = {
        "codigoImpto": elementoI.codigoImpto,
        "descrImpto": elementoI.descrImpto,
        "porcImpto": elementoI.porcImpto,
        "valorImpto": elementoI.valorImpto,
      }
      creaColeccI.push(argsUpd)
    }
  })

//PARA CUANDO SE FACTURA UN MES ANTERIOR
  let tieneMCCMesAnt = true
  //let lista8CC = listColeccRPCC

  let agno = fechaHoy.substr(0, 4)
  let mes = fechaHoy.substr(5, 2)
  let difmesesUMF = ((parseInt(agno, 10) * 12) + parseInt(mes, 10)) - ((parseInt(ultMF.substr(0,4), 10) * 12) + parseInt(ultMF.substr(5,2), 10))
// console.log(difmesesUMF)
//Si el la dif de meses entre hoy y el ult mes fact es > 1 => se verifica si el mes ant tiene mov
//en movcliccs
  if(difmesesUMF>1){
    let mesMA = parseInt(mes, 10)
    let agnoMA = agno
    if(mes==="01"){
      agnoMA = (parseInt(agno, 10) - 1).toString()
      mesMA = "12"
    }else{
      mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
    }
// console.log(agnoMA + "-" + mesMA)
    let indexFrado = listColeccRPCC.findIndex(servicio => (servicio.agno + "-" + servicio.mes)===(agnoMA + "-" + mesMA));
    if(indexFrado===-1){
//NO tiene mov del mes anterior en movcliccs => se pasa a veros2.js para que marque un detalle en movcliccs
//como NO FACTURAR
      tieneMCCMesAnt = false
    }  
  }

//verificar si NO tiene mov en el mes ant
  if(!tieneMCCMesAnt){
//verificar si esta des, sus o ret, la os lo va a pasar a act
    if(data.estadoCliente==="DESCONECTADO"||data.estadoCliente==="SUSPENDIDO"||
      data.estadoCliente==="RETIRADO"){
//crear mov en movcliccs con valor 0 y periodo NO FACTURAR para que no facture el mes
//esto porque cuando pasa a act, viene dx desde hace 2 meses y no se le debe fact
      let fechaHoyMA = new Date()
      let agnoMA = (fechaHoyMA.getFullYear()).toString()
      let mesMA = (((fechaHoyMA.getMonth()+1)<10?'0'+(fechaHoyMA.getMonth()+1):(fechaHoyMA.getMonth()+1))).toString()
      mesMA = parseInt(mesMA, 10)
      if(mesMA==="01"){
        agnoMA = (parseInt(agnoMA, 10) - 1).toString()
        mesMA = "12"
      }else{
        mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
      }
    // let periodoFradoMA = agnoMA + "-" + mesMA + "-01 a " + agnoMA + "-" + mesMA + "-30"
      let periodoFradoMA = "NO FACTURAR"
// let pruebaFMA =[]
// pruebaFMA.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,

      argsUpd = {}
      argsUpd = {
        "contrato": data.contrato,
        "fechaMov": fechaHoy,
        "tipo": "C",
        "subTipo": "RX",
        "procesado": "N",
        "codigoServicio": elemento1.codigoServicio,
        "nombreResumido": elemento1.nombreResumido,
        "descripcionServicio": elemento1.descripcionServicio,
        "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
        "periodo": periodoFradoMA,
        "origen": "DX-" + data.numeroOdeDX,
        "saldoCliente": saldoCl,
        "valorTotal": 0,
        "valorAntesImptos": 0,
        "agno": agnoMA,
        "mes": mesMA,
        "valorPagado": 0,
        // "valorPendiente": elemento1.valorTotal - valorPag,
        "usuarioCreate": userLogin,
        "imptos": []
      };
      creaColecc.push(argsUpd)
    }
  }
//FIN PARA CUANDO SE FACTURA UN MES ANTERIOR

  argsUpd = {}
  argsUpd = {
    "contrato": data.contrato,
    "fechaMov": fechaHoy,
    "tipo": "C",
    "subTipo": "RX",
    "procesado": "N",
    "codigoServicio": elemento1.codigoServicio,
    "nombreResumido": elemento1.nombreResumido,
    "descripcionServicio": elemento1.descripcionServicio,
    "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
    "periodo": periodoFrado,
    "origen": "DX-" + data.numeroOdeDX,
    "saldoCliente": saldoCl,
    "valorTotal": valorServ,
    "valorAntesImptos": valorAntesI,
    "agno": agnoFra,
    "mes": mesFra,
    "valorPagado": valorPag,
    // "valorPendiente": elemento1.valorTotal - valorPag,
    "usuarioCreate": userLogin,
    "imptos": creaColeccI
  };
  creaColecc.push(argsUpd)
// console.log(creaColecc)
// console.log("66")

//Verificar si el servicio tiene oferta
  if(data.oferta.codigoOferta){
    let elemento3Of = data.oferta

    elemento3Of.servicios.forEach((elementoOf, i) => {
// console.log(elementoOf)
      if(elementoOf.codigoServicio === elemento1.codigoServicio){
        let fechaInicial, fechaFinal
        !elementoOf.fechaInicioOferta?fechaInicial = fechaHoy:fechaInicial = elementoOf.fechaInicioOferta
        if(!elementoOf.fechaFinOferta){
          fechaFinal = new Date(elementoOf.fechaInicioOferta?elementoOf.fechaInicioOferta:fechaHoy)
          fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(elementoOf.numDiasOferta, 10))
          fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
        }else{
          fechaFinal = elementoOf.fechaFinOferta
        }

        let fechaInicio = new Date(fechaInicial).getTime();
        let fechaFin    = new Date(fechaFinal).getTime();
        let numdiApliOf = parseInt((fechaFin - fechaInicio) / (1000*60*60*24), 10)
        if(numdiApliOf>numDF){
          numdiApliOf = numDF
        }

// console.log(elemento.codigoServicio)
        let valorDcto = 0
        let valorDctoAI = 0
        if(numDF===numdiApliOf){
          // console.log("of11")
          valorDcto = creaColecc[0].valorTotal - (creaColecc[0].valorTotal * elementoOf.porcDctoOferta / 100)
          valorDctoAI = creaColecc[0].valorAntesImptos - (creaColecc[0].valorAntesImptos * elementoOf.porcDctoOferta / 100)
        }else{
          // console.log("of22")
          valorDcto = (creaColecc[0].valorTotal - (creaColecc[0].valorTotal * elementoOf.porcDctoOferta / 100)) / numDF
          valorDcto = valorDcto * numdiApliOf
          valorDctoAI = (creaColecc[0].valorAntesImptos - (creaColecc[0].valorAntesImptos * elementoOf.porcDctoOferta / 100)) / numDF
          valorDctoAI = valorDctoAI * numdiApliOf
        }
        // const indexLis = creaColecc.findIndex(codServ => codServ.codigoServicio === elemento2.codigoServicio);
        valorDcto = parseInt(valorDcto, 10)
        valorDctoAI = parseInt(valorDctoAI, 10)
        // console.log(valorDcto)
        if(valorDcto!==0){
          saldoCl += valorDcto - valorServ
          creaColecc[0].valorTotal = valorDcto
          creaColecc[0].valorAntesImptos = valorDctoAI
          creaColecc[0].saldoCliente = saldoCl

//Actualizar imptos con la oferta
          creaColecc[0].imptos.forEach((elemento2, i) => {
            elemento2.valorImpto = Math.round(valorDctoAI * elemento2.porcImpto / 100)
          })
        }else{
          // if(indexLis!==-1){
//pongo comentario porque no veo para que se elimina del array => ????
// creaColecc.splice(indexLis, 1);
          // }
        }
      }
    })
  }
  
  let colecc = {creaColecc, saldoCl}

  return colecc
}

export default rpArgsRx
  